import { message } from "antd";
import { connect } from "react-redux";

import PropTypes from "prop-types";
import React, { Component } from "react";
import { apiCallback } from "../../ApiHandlers/Common";
import { convertServiceProviderListToDropdown } from "../../Helpers/ServiceProviderHelpers";
import { withRouter } from "react-router-dom";
import ListAssetManagement from "./ListAssetManagement";

import MainPage from "../MainPage";
import { NavMenuItems } from "../../Constants/Constants";
class AssetManagement extends Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.codeManagement.icon()}
        <span>{NavMenuItems.codeManagement.label}</span>
      </>,
    ];
    this.state = {
      providerData: [],
      providerDataLoading: false,
      selectedProvider: null,
      selectedProviderName: null,
    };
  }
  componentDidMount() {
    this.updateProviderList();
  }

  updateProviderList = () => {
    const { history, serviceProviderApi } = this.props;
    this.setState({ providerDataLoading: true });

    const errorCallback = (error) => {
      this.setState({ providerDataLoading: false });
      message.error("Error fetching Service Provider list");
    };
    const successCallback = (data) => {
      const providerData = convertServiceProviderListToDropdown(data);
      this.setState({ providerData, providerDataLoading: false });
    };
    try {
      serviceProviderApi.getServiceprovider(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };
  onProviderSelect = (id, value) => {
    if (value) {
      this.setState({
        selectedProvider: id,
        selectedProviderName: value.children,
      });
    } else {
      this.setState({ selectedProviderName: null, selectedProvider: null });
    }
  };
  render() {
    const {
      providerData,
      providerDataLoading,
      selectedProvider,
      selectedProviderName,
    } = this.state;

    return (
      <MainPage>
        <div>
          <ListAssetManagement
            providerData={providerData}
            providerDataLoading={providerDataLoading}
            selectedProvider={selectedProvider}
            onProviderSelect={this.onProviderSelect}
            selectedProviderName={selectedProviderName}
            parentBread={this.header}
          />
        </div>
      </MainPage>
    );
  }
}
AssetManagement.propTypes = {
  serviceProviderApi: PropTypes.object,
  erviceProviderApi: PropTypes.object,
  providerData: PropTypes.array,
  providerDataLoading: PropTypes.bool,
  selectedProvider: PropTypes.string,
  onProviderSelect: PropTypes.func,
};
const mapStateToProps = (state) => ({
  serviceProviderApi: state.apis.serviceProviderApi,
});
const connectedAssetManagement = connect(mapStateToProps)(AssetManagement);
export default withRouter(connectedAssetManagement);
